import React from "react";
import { Video } from "lucide-react";
import ComingSoon from "../components/ComingSoon";

const VideoAI = () => (
  <ComingSoon
    icon={Video}
    title="Chức năng đang phát triển"
    description="Video AI sẽ sớm ra mắt. Hãy theo dõi các cập nhật tiếp theo."
  />
);

export default VideoAI;